"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClassVisitor = void 0;
const ast_1 = require("@wapc/widl/ast");
const helpers_1 = require("./helpers");
const decoder_visitor_1 = require("./decoder_visitor");
const encoder_visitor_1 = require("./encoder_visitor");
const utils_1 = require("../utils");
class ClassVisitor extends ast_1.BaseVisitor {
    constructor(writer) {
        super(writer);
    }
    visitTypeBefore(context) {
        super.triggerTypeBefore(context);
        this.write(utils_1.formatComment("// ", context.type.description));
        this.write(`export class ${context.type.name.value} implements Codec {\n`);
    }
    visitTypeField(context) {
        const field = context.field;
        this.write(utils_1.formatComment("  // ", field.description));
        this.write(`  ${field.name.value}: ${helpers_1.expandType(field.type, true, helpers_1.isReference(field.annotations))} = ${helpers_1.defValue(field)};\n`);
        super.triggerTypeField(context);
    }
    visitTypeFieldsAfter(context) {
        this.write(`\n`);
        const decoder = new decoder_visitor_1.DecoderVisitor(this.writer);
        context.type.accept(context, decoder);
        this.write(`\n`);
        const encoder = new encoder_visitor_1.EncoderVisitor(this.writer);
        context.type.accept(context, encoder);
        this.write(`\n`);
        this.write(`  toBuffer(): ArrayBuffer {
      let sizer = new Sizer();
      this.encode(sizer);
      let buffer = new ArrayBuffer(sizer.length);
      let encoder = new Encoder(buffer);
      this.encode(encoder);
      return buffer;
    }\n`);
        super.triggerTypeFieldsAfter(context);
    }
    visitTypeAfter(context) {
        this.write(`}\n\n`);
        super.triggerTypeAfter(context);
    }
}
exports.ClassVisitor = ClassVisitor;
//# sourceMappingURL=class_visitor.js.map